import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { ServiceHelper } from 'src/app/core/helper/services.helper';
import { Utilities } from 'src/app/core/helper/util';
import { Log } from 'src/app/core/log';
import { CommunityUser } from 'src/app/data/schema/community-user';
import { AiService } from 'src/app/data/service/ai.service';

@Component({
  selector: 'app-ai-helper',
  templateUrl: './ai-helper.component.html',
  styleUrls: ['./ai-helper.component.scss'],
})
export class AiHelperComponent implements OnInit {

  @ViewChild('myAudio', {static: false}) myAudio: ElementRef;
  
  isSubmitting: boolean = false;
  isRecording: boolean = false;
  get label() { return this.isSubmitting ? 'Processing...' : (this.isRecording ? 'Done' : 'Ask Question') }

  audioSrc: SafeUrl;
  mediaRecorder: MediaRecorder;
  mediaChunks: Blob[]; 

  // making these static so search results not lost on close of modal
  static _prompt: string;
  answer: string = '';

  get prompt() {return AiHelperComponent._prompt};
  set prompt(v: string) { AiHelperComponent._prompt = v; };

  state: number = 0; // 0 - press to start, 1 - recording, 2 - submi

  // will get generated image base64
  base64Image: string;
  base64Images: string[] = [];

  imageMode: boolean = false;

  profile: CommunityUser;

  // first image selection is to upsize, then to use
  gotVariations: boolean = false;

  constructor(
    private aiSvc: AiService,
    private modalCtrl: ModalController) {
   }

  async ngOnInit() {
    Log.debug('ai helper, got prompt: ' + this.prompt)
    this.profile = await CommunityUser.myProfile();

    if ( Utilities.stringEmpty(AiHelperComponent._prompt) ) {
      AiHelperComponent._prompt = undefined;
    }
  }

  toggleCapture() {
    this.isRecording = !this.isRecording;
    if ( this.isRecording){
      this.mediaChunks = [];
      this.startRecording();
    } else {
      this.isSubmitting = true;
      this.stopRecording();
    }
  }

  startRecording() {
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then((stream) => {
        this.mediaRecorder = new MediaRecorder(stream);
        this.mediaChunks = [];
  
        // Prepare the audio data as chunks
        this.mediaRecorder.addEventListener('dataavailable', (event) => {
          if (event.data.size > 0) {
            this.mediaChunks.push(event.data);
          }
        });
  
        // When recording stops, create a new audio blob and save it as audioSrc
        this.mediaRecorder.addEventListener('stop', () => {
          const audioBlob = new Blob(this.mediaChunks, { type: 'audio/ogg' });
          this.doSomethingWithAudio(audioBlob);
        });
  
        // Start recording
        this.mediaRecorder.start();
      })
      .catch((error) => console.error(error));
  }

  stopRecording() {
    if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
      this.mediaRecorder.stop();
    }

    // ensure we fully release all references to microphone
    const tracks = this.mediaRecorder.stream.getTracks();
    tracks.forEach(function(track) {
      track.stop();
    });
  }

  async doSomethingWithAudio(audioBlob: Blob) {

    try {
      const resp = await this.aiSvc.submitAudioPrompt(audioBlob, this.imageMode, null);
      this.processResponse(resp);
    }catch(error) {
      console.error(error)
      ServiceHelper.displayAlert("Error", "We apologize, but we were unable to process your request")
    }finally{
      this.isSubmitting = false;
      this.isRecording = false;
    }
  }

  async submitPrompt() {
    if ( Utilities.stringEmpty(this.prompt) ) {
      ServiceHelper.displayAlert('No Prompt', 'Please enter a prompt before unleashing Bobbee!');
      return;
    }
    try {
      Log.debug('is image: '+ this.imageMode) 
      this.isSubmitting = true;
      const resp = await this.aiSvc.submitPrompt(this.prompt, this.imageMode, null);
      this.processResponse(resp);
    }catch(error) {
      console.error(error)
      ServiceHelper.displayAlert("Error", "We apologize, but we were unable to process your request")
    }finally{
      this.isSubmitting = false;
    }
  }

  processResponse(response: string) {
      const respObj = JSON.parse(response);
      Log.debug('response: ', respObj);
      AiHelperComponent._prompt = respObj.prompt;
      
      if ( respObj.imagesBase64 != null ) {
        for(let x = 0; x < respObj.imagesBase64.length; x++){
          this.base64Images.unshift( respObj.imagesBase64[x]);
        }
      }
      else if ( respObj.imageBase64 != null ) {
        this.base64Image = respObj.imageBase64;
      } else {
        this.answer = respObj.answer;
        if ( this.answer.includes('safety system')) {
          this.answer += '\n Copywritten names and inappropriate quests will be rejected by the system. '
        }
      }
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  useResponse() {
    this.modalCtrl.dismiss({answer: this.answer});
  }
  

  async useImage(img: string, requestVariation: boolean) {

    if ( requestVariation == true ) {
      this.gotVariations = true;
      const load = await ServiceHelper.displayLoad('Getting Variations... scroll down to see them after they arrive!')
      const resp = await this.aiSvc.upsizeImage(img);
      this.processResponse(resp);
      load.dismiss();
    } else {
      this.modalCtrl.dismiss({imageBase64: 'data:image/png;base64,' + img});
    }
  }
}
